export default __webpack_public_path__ + "static/media/cpThaiStampBanner.632040d6.jpg";